module.exports = __webpack_public_path__ + "img/img_logo.dd236adf.svg";